import React from "react";
import classNames from "classnames";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { useFinancialAccountEntitySelection } from "@hooks/useFinancialAccountEntitySelection";
import styles from "./AccountConnectionWidget/AccountsConnectionWidget.module.scss";
import { useFinancialAccountsConnectionContext } from "./FinancialAccountsConnectionContext";
import { FinancialAccountConnectionRow } from "./FinancialAccountConnectionRow";
import { isValidAccount } from "./helpers";

interface AccountConnectionWidgetProps {
    accounts: IntegrationAccount[];
    connection?: FinancialConnection;
}

export const FinancialAccountsConnectionWidget: React.FC<
    AccountConnectionWidgetProps
> = ({ accounts, connection }) => {
    const { showBusinessEntitySelection } =
        useFinancialAccountEntitySelection();
    const entitySelection = showBusinessEntitySelection;
    const { showAccountTypeWarning } = useFinancialAccountsConnectionContext();
    const hasError =
        showAccountTypeWarning &&
        accounts.some(
            (a) => a.financialAccount && !isValidAccount(a.financialAccount),
        );

    return (
        <table
            className={classNames("table", styles.root, {
                [styles.error]: hasError,
            })}
        >
            <thead>
                {entitySelection && accounts.length > 0 && (
                    <tr
                        className={classNames(
                            "small",
                            "text-grey",
                            styles.headerLabels,
                        )}
                    >
                        <th>Account</th>
                        <th aria-label="Warning"></th>
                        <th>Entity</th>
                    </tr>
                )}
            </thead>

            <tbody>
                {accounts.length > 0 ? (
                    <>
                        {accounts.map(
                            (account) =>
                                account.financialAccount && (
                                    <FinancialAccountConnectionRow
                                        key={account.id}
                                        integrationAccount={account}
                                        financialAccount={
                                            account.financialAccount
                                        }
                                        connection={connection}
                                    />
                                ),
                        )}
                    </>
                ) : null}
            </tbody>
        </table>
    );
};
